import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import truncate from 'lodash/truncate';
import ProjectLink from 'common/containers/project_link';
import StarRating from 'common/components/star_rating';
import Menu from 'entries/containers/actions_menu';

export default class NameDenseItem extends Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
    this.handleRate = this.handleRate.bind(this);
  }

  handleDelete(e) {
    const { item, onDelete } = this.props;

    e.preventDefault();
    e.stopPropagation();

    onDelete(item);
  }

  handleRate(rating) {
    const { item, onRate } = this.props;
    onRate(item, rating);
  }

  render() {
    const { item, project, canViewRating, canRate, canDelete } = this.props;
    const revision = item.revisions[0];

    return (
      <tr>
        <td className="entry-name">
          <ProjectLink project={project} append={`entry/${item.id}/`}>
            <span className="hide-for-small-only">{ revision.name }</span>
            <span className="show-for-small-only">{ truncate(revision.name, { length: 30 }) }</span>
          </ProjectLink>
        </td>
        <td className="hide-for-small-only">
          <Link to={`/users/${item.author_username}/`} target="_blank">
            { item.author_username }
          </Link>
        </td>
        <td className="hide-for-small-only">{ moment(revision.created_at).fromNow() }</td>
        <td>
          { item.withdrawn && <span className="message">withdrawn</span> }
          { item.eliminated && <span className="message">eliminated</span> }
          { canViewRating &&
          <StarRating min={1} readonly={!canRate} initialRate={revision.score || 0}
            onChange={this.handleRate}/> }
        </td>

        <td className="actions hide-for-small-only">
          { canDelete && <button className="fa fa-trash" onClick={this.handleDelete} /> }
          <Menu entry={item} />
        </td>
      </tr>
    );
  }
}

NameDenseItem.propTypes = {
  item: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  canViewRating: PropTypes.bool.isRequired,
  canRate: PropTypes.bool.isRequired,
  canDelete: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRate: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/name_dense_item.jsx